import { get } from 'lodash';

import { EMPLOYMENT_TYPE, FIELD_PATHS } from '@funnels/constants';
import { useCustomer, useFormValues } from '@funnels/hooks';
import { ApplicantEntityIndex, Income, StoreEmployment } from '@funnels/types';
import { Accordion, AccordionGroup } from '@funnels/ui-components/Common';
import { CompanyMerger } from '@funnels/ui-components/RelatedCompany';
import { Card } from '@funnels/ui-layouts/customer-view/_common';
import { initialFormValues, maskPIIFullStory } from '@funnels/utils';

import { EmploymentSituation } from '../../Layout';

interface AdditionalEmploymentsProps extends ApplicantEntityIndex {
  isFromSummary?: boolean;
}

export const AdditionalEmployments = (props: AdditionalEmploymentsProps) => {
  const { applicantIndex, isFromSummary } = props;
  const customer = useCustomer();
  const [formValues, setFormValue] = useFormValues();
  const applicantId = get(formValues, FIELD_PATHS.APPLICANT_ID(applicantIndex));
  const applicantCustomerId = get(formValues, FIELD_PATHS.APPLICANT_CUSTOMER_ID(applicantIndex));
  const applicantFirstName = get(formValues, FIELD_PATHS.APPLICANT_FIRST_NAME(applicantIndex));
  const isLoggedInApplicant = applicantCustomerId === customer.data.id;
  const employments: StoreEmployment[] = get(formValues, FIELD_PATHS.EMPLOYMENTS(), []);
  const incomes: Income[] = get(formValues, FIELD_PATHS.INCOMES(), []);
  let additionalEmploymentCount = 0;

  const handleAddAdditionalEmployment = () => {
    const type = EMPLOYMENT_TYPE.SECONDARY;
    const newEmployment = initialFormValues.INITIAL_EMPLOYMENT_V2(applicantId, type);
    setFormValue(FIELD_PATHS.EMPLOYMENT(employments.length), newEmployment);
  };

  const handleDeleteAdditionalEmployment = (employmentIndex: number) => {
    const employmentClientId = get(formValues, FIELD_PATHS.EMPLOYMENT_CLIENT_ID(employmentIndex));
    setFormValue(
      FIELD_PATHS.EMPLOYMENTS(),
      employments.filter((_, index) => index !== employmentIndex)
    );
    setFormValue(
      FIELD_PATHS.INCOMES(),
      incomes.filter(
        (_: Income, index: number) =>
          get(formValues, FIELD_PATHS.INCOME_EMPLOYMENT_CLIENT_ID(index)) !== employmentClientId
      )
    );
  };

  const heading = isLoggedInApplicant ? (
    'Do you have any additional jobs?'
  ) : (
    <>Does {maskPIIFullStory(applicantFirstName)} have any additional jobs?</>
  );

  return (
    <Card heading={heading} actionCustomText={isFromSummary ? 'Save' : 'Next'}>
      <CompanyMerger />
      <AccordionGroup addButtonText="Add Additional Employment" onAdd={handleAddAdditionalEmployment}>
        {employments.map((_, index) => {
          if (
            get({ employments }, FIELD_PATHS.EMPLOYMENT_APPLICANT_ID(index)) === applicantId &&
            get({ employments }, FIELD_PATHS.EMPLOYMENT_TYPE(index)) === EMPLOYMENT_TYPE.SECONDARY
          ) {
            return (
              <Accordion
                headerText={`Additional employment ${++additionalEmploymentCount}`}
                onPrimaryButtonClick={() => {
                  handleDeleteAdditionalEmployment(index);
                }}
                key={get({ employments }, FIELD_PATHS.EMPLOYMENT_CLIENT_ID(index))}
              >
                <EmploymentSituation employmentIndex={index} applicantId={applicantId} />
              </Accordion>
            );
          } else {
            return null;
          }
        })}
      </AccordionGroup>
    </Card>
  );
};
